module.exports = __webpack_public_path__ + "img/2.c54fb016.png";